import { createContext, useContext, useState } from 'react';

const QuoteDrawerContext = createContext(null);

export function QuoteDrawerProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [prefill, setPrefill] = useState({});

  const openDrawer = (data = {}) => {
    setPrefill(data);
    setIsOpen(true);
  };

  const closeDrawer = () => {
    setIsOpen(false);
    setPrefill({});
  };

  return (
    <QuoteDrawerContext.Provider value={{ isOpen, prefill, openDrawer, closeDrawer }}>
      {children}
    </QuoteDrawerContext.Provider>
  );
}

export const useQuoteDrawer = () => useContext(QuoteDrawerContext);
